export default "__VITE_ASSET__DvpssgLq__"